

<!-- Header Section -->
<div class="page-header col-md-12 p-3">
    <div class="row">
      <div class="col-md-4">
        <h3 class="page-title" translate>Edit Appointment</h3>
        <ol class="breadcrumb bg-white p-0">
          <li class="breadcrumb-item active" aria-current="page">Edit Appointment</li>
        </ol>
      </div>
      <div class="col-md-8 d-none d-md-flex justify-content-md-end align-items-center">

        <button class="btn btn-sm mx-1 border border-white rounded"  (click)='backClicked()' translate ><i class="fa fa-times"></i> BACK</button>
      </div>
  
      <!-- Mobile Dropdown -->
      <div class="col-12 d-flex d-md-none justify-content-end">
        <div ngbDropdown class="d-flex d-md-none justify-content-end mt-2">
            <button class="btn btn-light border no-arrow" ngbDropdownToggle>
                <i class="fa fa-ellipsis-h"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu-right">
                <a class="dropdown-item border-bottom p-2"  (click)='backClicked()' translate ><i class="fa fa-times mr-1"></i> BACK </a>
            
              
      </div>
      </div>
  </div>
  </div>
  </div>
 



  <div class="row px-3 mt-2">
  
    <div class="d-flex flex-column justify-content-between  row w-100 m-0">



<!--{{appointmentForm.value | json }}-->



<div class="jumbotron p-0 bg-white" >
                <div class="container ">
                    <div class="row">
                        <div class="col-md-12 p-0 ">

                            <form [formGroup]="appointmentForm" class="text-center border border-light p-3">

                           

                                <div class="float-right w-100">
                                    <h3 class="float-left align-center py-3 text-danger"></h3> <div class="float-left py-4 text-danger" style="font-family:'DINPro'" translate>* mandatory fields</div>
                                </div>
                                <br>
                                


                                <div class="row w-100 d-flex justify-content-between p-2">
                                    <div class="col-md-5 form-group py-2">
                                        <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Status</label>
                                        <select class="form-control select2tag select2-hidden-accessible"
                                            formControlName="status" id="status" name="status" style="width: 100%;"
                                            tabindex="-1" aria-hidden="true" [class.is-invalid]="formErrors.status"
                                            (blur)="logValidationErrors(appointmentForm)">
                                            <option value=''>SELECT</option>
                                            <option value="In Progress">In Progress</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Completed">Completed</option>
                                            <option value="Cancelled">Cancelled</option>
                                            <option value="No Show">No Show</option> 
                                            
                                        </select>
                                        <div [class.d-none]="!formErrors.status">
                                            <small clas="text-danger">{{formErrors.status}}</small></div>
                                    </div>
    
    
                                    <div class="col-md-5 form-group py-2">
                                      
                                            <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Request Type</label>
                                            <select class="form-control select2tag select2-hidden-accessible"
                                                formControlName="requestType" id="requestType" name="requestType" 
                                                tabindex="-1" aria-hidden="true" 
                                               >
                                                <option value='Appointment'>Appointment</option>
                                                <option value="Browsing">Browsing</option> 
                                                <option value="Euro Lagno">Euro Lagno</option> 
                                                <option value="Walk-In">Walk-In</option>
                                                <option value="Phone">Phone</option>
                                                <option value="Email">Email</option>
                                                <option value="Previous">Previous</option> 
                                                <option value="Virtual Appointment">Virtual Appointment</option>
                                                <option value="Virtual Inquiry">Virtual Inquiry</option>
                                            </select>
        
                                        </div>
    
                                    </div>
    
                                
                                
                                <div class="row w-100 d-flex justify-content-between px-2" *ngIf='!isSalesRep()'>
                                 
     
                                    <div class="col-md-5 form-group py-2 ">
                                      
                                        <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" for="timeIn" translate>Time In</label>
                                          <app-date-time-picker  formControlName="timeIn"  name="timeIn"></app-date-time-picker>   
                                </div>
    
    
                                    <div class="col-md-5 form-group py-2 ">
                                      
                                        <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" for="timeOut" translate>Time Out</label>
                                          <app-date-time-picker  formControlName="timeOut"  name="timeOut"></app-date-time-picker>   
                               

                                    </div>

                   <!--                 <div class="col-md-5 form-group py-2 ">
                                       
                                         <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Time In</label>
                                         <div class="d-flex justify-content-around">
                                         <input type="text " formControlName="timeIn" class="form-control w-75 float-left  "
                                            />
                                           <button class="btn btn-dark " (click)=patchCheckIn() >Check In</button>
                                        </div>
     
                                     </div>
     
     
                                     
                                     <div class="col-md-5 form-group py-2 mx-1">
                                       
                                        <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Time Out</label>
                                        <div class="     d-flex justify-content-around">
                                        <input type="text " formControlName="timeOut" class="form-control  float-left  " style="width: 72%;"
                                           />
                                          <button class="btn btn-dark " (click)=patchCheckOut()>Check Out</button>
                                       </div>
    
                                    </div>-->
                                 </div>




                                <div class="row w-100 d-flex justify-content-between p-2">
                               <div class="col-md-5 form-group py-2">
                                    <label translate class="text-left font-weight-bold p-2 rounded w-100 " style="font-family:'DINPro'">Full
                                        Name<i class="text-danger ">*</i></label>
                                    <input type="text" formControlName="fullName" class="form-control "
                                        [class.is-invalid]="formErrors.fullName"
                                        (blur)="logValidationErrors(appointmentForm)" />

                                    <div [class.d-none]="!formErrors.fullName">
                                        <small class="text-danger">{{formErrors.fullName}}</small></div>
                                </div>



                                <div class="col-md-5 form-group py-2">
                                    <label translate class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Email</label>
                                    <input type="text" formControlName="email" class="form-control"
                                        [class.is-invalid]="formErrors.email"
                                        (blur)="logValidationErrors(appointmentForm)" />

                                    <div [class.d-none]="!formErrors.email">
                                        <small>{{formErrors.email}}</small></div>

                                </div>


                            </div>




                            <div class="row w-100 d-flex justify-content-between p-2">
                                <div  translate class="col-md-5 form-group py-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Phone
                                        Number</label>
                                    <input type="text" formControlName="phoneNumber" class="form-control"
                                        [class.is-invalid]="formErrors.phoneNumber"
                                        />

                                    
                                </div>


                                <div class="col-md-5 form-group py-2">
                                    <label  translate class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">What age
                                        group do you belong to?</label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="ageGroup" id="ageGroup" name="ageGroup" style="width: 100%;"
                                        tabindex="-1" aria-hidden="true" >
                                      
                                        <option value="18-24">18 - 24</option>
                                        <option value="25-34">25 - 34</option>
                                        <option value="35-44">35 - 44</option>
                                        <option value="35-44">45 - 54</option>
                                        <option value="35-44">55 - 64</option>
                                        <option value="35-44">65 - up</option>
                                    </select>

                                

                                </div>


                            </div>




                            <div class="row w-100 d-flex justify-content-between p-2">
                                <div class="col-md-5 form-group py-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Person Count</label>
                                    <input type="text" formControlName="personCount" class="form-control"
                                         />

                             
                                </div>


                                <div class="col-md-5 form-group py-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Clientele</label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="clientele" id="clientele" name="clientele" style="width: 100%;"
                                        tabindex="-1" aria-hidden="true" 
                                     >
                                        
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Group">Group</option>
                                        <option value="Couple">Couple</option>
                                        <option value="Family">Family</option>
                                        
                                    </select>


                                </div>


                            </div>

                            
                            <div class="row w-100 d-flex justify-content-between p-2" >
                             
                                <div class="col-md-5  form-group py-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Please select location for appointment?<i class="text-danger ">*</i></label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="branch" id="branch" name="branch"
                                        style="width: 100%;" tabindex="-1" aria-hidden="true" (change)='getSalesRep($event.target.value)'
                                   >
                                      
                                        <option *ngFor='let branch of branchs' value={{branch}}>{{branch}}</option>
                                    
                                    </select>


                                </div>
                             
                                <div class="col-md-5 form-group py-2" *ngIf='branchselected'>
                                <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Sales Representative<button class="rounded mx-2 bg-dark text-white" (click)="unassignSalesRep()">Unassign</button></label>
                                <select class="form-control select2tag select2-hidden-accessible"
                                    formControlName="salesRepID" id="salesRepID" name="salesRepID"
                                    style="width: 100%;" tabindex="-1" aria-hidden="true"
                                    
                                    (blur)="logValidationErrors(appointmentForm)">
                                    <!--<option value='0'>SELECT</option>-->
                                    <option *ngFor='let rep of salesRep' value={{rep.userID}}>{{rep.fullName}}
                              
                                </select>

                            </div>

                        </div>



                        <div class="form-group p-2">
                            <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Tag</label>
                            <input type="text" formControlName="tag" class="form-control" />
    
                        </div>


                        <div class="form-group p-2">
                        <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Link (Website, Zoom, Ms Teams, etc)</label>
                        <input type="text" formControlName="webLink" class="form-control" />

                    </div>


                            <div class="form-group p-2 ">
                                <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>COVID</label>
                                <select class="form-control select2tag select2-hidden-accessible"
                                    formControlName="covid" id="covid" name="covid"
                                    style="width: 100%;" tabindex="-1" aria-hidden="true"
                                    
                                    (blur)="logValidationErrors(appointmentForm)">
                                  
                                    <option value="Pass">Pass</option>
                                    <option value="Fail">Fail</option>
                                    
                                </select>

                            </div>



                           

                            <div class="form-group p-2" hidden>
                            <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Notes</label>
                            <textarea type="text" formControlName="notes" class="form-control"> </textarea>

                        </div>




                                <div class="form-group p-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Type of client</label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="describesYou" id="describesYou" name="describesYou"
                                        style="width: 100%;" tabindex="-1" aria-hidden="true"
                                        >
                                   
                                        <option value="Builder">Builder</option>
                                        <option value="Designer">Contractor</option>
                                        <option value="Designer">Designer</option>
                                        <option value="Fabricator">Fabricator</option>
                                         <option value="Homeowner">Homeowner</option>
                                    </select>

                                   

                                </div>


                                <div class="form-group p-2"
                                    *ngIf="appointmentForm.get('describesYou').value=='Fabricator'|| appointmentForm.get('describesYou').value=='Designer'">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>What is the
                                        name of your company?</label>
                                    <input type="text" formControlName="companyName" class="form-control" />

                                </div>




                                <div class="form-group p-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Purpose of visit</label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="lookingFor" id="lookingFor" name="lookingFor"
                                        style="width: 100%;" tabindex="-1" aria-hidden="true"
                                        >
                                        
                                       
                                        <option value="All">All</option>
                                        <option value="Cut To Size">Cut To Size</option>
                                        <option value="Payment">Payment</option>
                                        <option value="Place Order">Place Order</option>
                                        <option value="Porcelain/Engineered Slabs">Porcelain/Engineered Slabs</option>
                                        <option value="Plumbing accessories">Plumbing accessories</option>
                                        <option value="Samples">Samples</option>
                                        <option value="Slabs">Slabs</option>
                                        <option value="Slab/Tiles"> Slab/Tiles</option>
                                        <option value="Tiles">Tiles</option>                                        
                                        <option value="Wood">Wood</option>
                                        
                                       
                                        
                                    </select>

                                   

                                </div>





                                <div class="form-group p-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>How did you hear about us?</label>
                                    <!--<input type="text" formControlName="heardAboutUs" class="form-control" />-->
                                    <select class="form-control select2tag select2-hidden-accessible"
                                    formControlName="heardAboutUs" id="heardAboutUs" name="heardAboutUs"
                                    style="width: 100%; font-family:'DINPro'" tabindex="-1" aria-hidden="true"
                                   >
                                    
                                    <option value="Drive By">Drive By</option>
                                    <option value="Designer">Designer</option>
                                    <option value="Contractor"> Contractor</option>
                                    <option value="Fabricator">Fabricator</option>
                                    <option value="Family/Friends">Family/Friends</option>
                                    <option value="Social Media">Social Media</option>
                                    <option value="TV Ad">TV Ad</option>
                                    <option value="Boxing Week Sale">Boxing Week Sale</option>
                                  
                                </select>

                                    <!--<div class="d-flex flex-wrap">
<label class="m-2">
    <input class="mx-1" type="checkbox" [checked]="appointmentForm.controls['heardAboutUs'].value=='Drive By'"  (change)="appointmentForm.controls['heardAboutUs'].setValue('Drive By');heardAbout='Drive By';"/>Drive By
</label>
<label class="m-2">
<input class="mx-1" type="checkbox"  [checked]="appointmentForm.controls['heardAboutUs'].value=='Designer'" (change)="appointmentForm.controls['heardAboutUs'].setValue('Designer');heardAbout='Designer'"/>Designer
</label>
<label class="m-2">
    <input  class="mx-1"type="checkbox"  [checked]="appointmentForm.controls['heardAboutUs'].value=='Contractor'" (change)="appointmentForm.controls['heardAboutUs'].setValue('Contractor');heardAbout='Contractor'"/>Contractor
        </label>
        <label class="m-2">
     <input class="mx-1" type="checkbox"  [checked]="appointmentForm.controls['heardAboutUs'].value=='Fabricator'" (change)="appointmentForm.controls['heardAboutUs'].setValue('Fabricator');heardAbout='Fabricator'"   />Fabricator
      </label>
      <label class="m-2">
     <input class="mx-1" type="checkbox"  [checked]="appointmentForm.controls['heardAboutUs'].value=='Family/Friends'" (change)="appointmentForm.controls['heardAboutUs'].setValue('Family/Friends');heardAbout='Family/Friend'"/>Family/Friend
       </label>
     <label class="m-2">
    <input class="mx-1" type="checkbox"  [checked]="appointmentForm.controls['heardAboutUs'].value=='Social Media'" (change)="appointmentForm.controls['heardAboutUs'].setValue('Social Media');heardAbout='Social Media'"/>Social Media
     </label>
     <label class="m-2">
        <input  class="mx-1" type="checkbox"  [checked]="heardAbout=='Other'" (change)="appointmentForm.controls['heardAboutUs'].setValue('');heardAbout='Other'"/>Other
        
</label>
<input type="text" *ngIf="heardAbout=='Other'" formControlName="heardAboutUs" class="form-control" />
</div>-->

                                </div>


                                <div class="form-group py-2 px-2 ">
                                    <label class="text-left font-weight-bold p-2 rounded w-100 " style="font-family:'DINPro'" translate>Are you with a fabricator? If yes, please indicate the name of the company.</label>
                                    <input type="text" formControlName="workWithFabricator" class="form-control" />
                                </div>


                                <div class="form-group m-2 text-center d-flex flex-column ">
                                
                  
                                    <div class="text-center"><button 
                                            [disabled]='!appointmentForm.valid || !appointmentForm.valid'
                                            data-toggle="modal" (click)=onSubmit() class="btn  text-white "
                                            style="align-content: center;  background: white;"><i
                                                class="fa fa-check"></i>
                                            Submit</button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>










        </div>
    </div>



<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

           <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';">THANK YOU </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" >Appointment has been saved.</h4>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" (click)='backClicked()'  data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>
</div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                       Error Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger">ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)='backClicked()' data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>